import React, { useState, useEffect } from "react"
import { RankingList } from "../../../components/RankingList"
import { IconChapa } from "../../../components/Icons"
import RankingHeader from "../../../components/RankingHeader";
import styled from "styled-components";
import { useHost } from "../../../hooks/userInfoService";
import { useResto } from "../../../hooks/useResto";
import { useTransaction } from "../../../hooks/useTransaction";
import { useUser } from "../../../hooks/useUser";

const Wrapper = styled.div`
    padding: .5rem 0;
`

const PointsContainer = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 6px;
`

export default function RankingPage() {
    const { getDataHost } = useHost();
    const { resto, getResto } = useResto();
    const { avatar } = useUser()
    const { ranking, getRanking, hostPosition, getHostPosition, rankingLoader } = useTransaction()
    const [selectedResto, setSelectedResto] = useState("1")
    const [title, setTitle] = useState(`Ranking ${resto?.name || ""}`)
    const [currentCountry, setCurrentCountry] = useState("Chile");

    useEffect(() => {
        getDataHost();
        getResto();
        getHostPosition();
        getRanking("resto");
    }, []);

    useEffect(() => {
        setTitle(`Ranking ${resto?.name || ""}`)
        setCurrentCountry(resto?.country);
    }, [resto]);

    const headers = [
        { key: "pos", label: "#" },
        { key: "avatar", label: "Almacenero", type: "avatar" },
        { key: "points", label: "Chapas", render: (row) => (<PointsContainer><IconChapa width="24" height="24" /><span>{row.points}</span></PointsContainer>) },
    ]


    const restoOptions = [
        { label: `${resto?.name || "Restaurante"}`, value: "resto" },
        { label: `${resto?.country || "Local"}`, value: "local" },
        { label: "Global", value: "global" },
    ]

    const handleChangeSelect = (value) => {
        setSelectedResto(value);
        getRanking(value);
        const t = restoOptions.find(r => r.value === value);
        setTitle(`Ranking ${t?.label || ""}`);
    }

    return (
        <Wrapper>
            <RankingHeader
                profile={avatar}
                localName={currentCountry}
                localPosition={hostPosition?.local || 0}
                localTotal={hostPosition?.localTotal || 0}
                latamPosition={hostPosition?.global || 0}
                latamTotal={hostPosition?.globalTotal || 0}
                level={hostPosition?.level || "-"}
                showLevel={true}
            />

            <RankingList
                title={title}
                headers={headers}
                data={ranking}
                selectable
                selectedValue={selectedResto}
                selectOptions={restoOptions}
                onSelectChange={handleChangeSelect}
                loading={rankingLoader}
            />
            <div style={{height: 100}}></div>
        </Wrapper>
    )
}
